import { render, staticRenderFns } from "./EditModal.vue?vue&type=template&id=45369e34&scoped=true&"
import script from "./EditModal.vue?vue&type=script&lang=ts&"
export * from "./EditModal.vue?vue&type=script&lang=ts&"
import style0 from "./EditModal.vue?vue&type=style&index=0&id=45369e34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45369e34",
  null
  
)

export default component.exports